import React, { PureComponent } from 'react';
import styled from 'styled-components';
import CreateTemplateBtn from './CreateTemplateBtn';
import DisplayIdLineUp from './DisplayIdLineUp';
import MakerTool from './MakerTool';
import ParticipantsPicker from './ParticipantsPicker';
import WidgetCustomLineUp from './WidgetCustomLineUp';
import EditWidgetBtn from './EditWidgetBtn';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import IconPictureInPicture from 'material-ui/svg-icons/action/picture-in-picture';
import { indigo500, grey300 } from 'material-ui/styles/colors';

const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 0.53em;
    padding-bottom: 0.53em;
`;

const HeaderLet = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding-top: 0.33em;
`;

const Title = styled.h2`
    color: ${indigo500};
    font-weight: inherit;
    margin-top: 0;
    margin-bottom: 0;

    svg {
        margin-right: 10px;
        transform: translate(0, 4px);
    }
`;

const Content = styled.div`
    display: flex;
    margin-bottom: 16px;
`;

const Widget = styled.div`
    display: flex;
    justify-content: center;
`;

const EditWidgetBtnWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
`;

const CardHeaderStyle = {
    borderBottom: `1px solid ${grey300}`,
    paddingTop: 0,
    paddingBottom: 0
};

const IconPacksStyle = {
    color: 'inherit'
};

const CardStyle = {
    marginBottom: 15
};

class MakerToolPage extends PureComponent {
    render() {
        return (
            <div>
                <Card style={CardStyle}>
                    <CardHeader style={CardHeaderStyle}>
                        <HeaderWrapper>
                            <HeaderLet>
                                <Title>
                                    <IconPictureInPicture style={IconPacksStyle} />Grid Maker Tool Page
                                </Title>
                                <DisplayIdLineUp />
                            </HeaderLet>
                            <CreateTemplateBtn />
                        </HeaderWrapper>
                    </CardHeader>
                    <CardText>
                        <Content>
                            <MakerTool />
                            <ParticipantsPicker />
                        </Content>
                        <Widget>
                            <WidgetCustomLineUp />
                        </Widget>
                        <EditWidgetBtnWrapper>
                            <EditWidgetBtn />
                        </EditWidgetBtnWrapper>
                    </CardText>
                </Card>
            </div>
        );
    }
}

export default MakerToolPage;



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/index.js
 **/